import { useEffect, useState } from "react";

// TODO: use useRef instead of DOM methods
const HEADER_ID = "dt-header";

export const useHeaderHeight = () => {
	const [headerHeight, setHeaderHeight] = useState(0);
	useEffect(() => {
		const getHeaderHeight = () => {
			if (typeof window === "undefined" || !window.document) return;
			const offsetHeight = document.getElementById(HEADER_ID)?.offsetHeight;
			const headerTop = Number.parseInt(
				document.getElementById(HEADER_ID)?.style.top.replace("px", ""),
			);
			if (!offsetHeight) {
				setHeaderHeight(0);
			} else if (!headerTop) {
				setHeaderHeight(offsetHeight);
			} else {
				setHeaderHeight(offsetHeight + headerTop);
			}
		};

		const interval = setInterval(getHeaderHeight, 100);
		return () => clearInterval(interval);
	}, []);

	return headerHeight;
};
